{
  "Accessibility Menu": "Erişilebilirlik Menüsü",
  "Reset settings": "Ayarları Sıfırla",
  "Close": "Kapat",
  "Content Adjustments": "İçerik Ayarları",
  "Adjust Font Size": "Yazı Tipi Boyutunu Ayarla",
  "Highlight Title": "Başlığı Vurgula",
  "Highlight Links": "Bağlantıları Vurgula",
  "Readable Font": "Okunaklı Yazı Tipi",
  "Color Adjustments": "Renk Ayarları",
  "Dark Contrast": "Koyu Kontrast",
  "Light Contrast": "Açık Kontrast",
  "High Contrast": "Yüksek Kontrast",
  "High Saturation": "Yüksek Doygunluk",
  "Low Saturation": "Düşük Doygunluk",
  "Monochrome": "Tek Renkli",
  "Contrast": "Kontrast",
  "Invert Colors": "Renkleri ters çevir",
  "Tools": "Araçlar",
  "Reading Guide": "Okuma Rehberi",
  "Stop Animations": "Animasyonları Durdur",
  "Big Cursor": "Büyük İmleç",
  "Increase Font Size": "Yazı Tipi Boyutunu Artır",
  "Decrease Font Size": "Yazı Tipi Boyutunu Azalt",
  "Letter Spacing": "Harf Aralığı",
  "Line Height": "Satır Yüksekliği",
  "Font Weight": "Yazı Tipi Kalınlığı",
  "Dyslexia Font": "Disleksi Yazı Tipi",
  "Language": "Dil",
  "Open Accessibility Menu": "Erişilebilirlik menüsünü aç",
  "Widget Settings": "Widget ayarları",
  "Widget Position": "Widget konumu",
  "Top Left": "Sol üst",
  "Top Center": "Üst orta",
  "Top Right": "Sağ üst",
  "Center Left": "Orta sol",
  "Center Right": "Orta sağ",
  "Bottom Left": "Sol alt",
  "Bottom Center": "Alt orta",
  "Bottom Right": "Sağ alt",
  "Screen Reader": "Ekran okuyucu",
  "Voice Navigation": "Sesli gezinme",
  "Custom Color": "Özel renk",
  "Change the site's colors": "Sitenin renklerini değiştir",
  "Backgrounds": "Arka planlar",
  "Headings": "Başlıklar",
  "Contents": "İçerikler",
  "Reset colors": "Renkleri sıfırla",
  "Image Desaturation": "Görüntü doygunluğunu azalt",
  "Search languages": "Dilleri ara",
  "No languages found": "Dil bulunamadı",
  "Accessibility Profiles": "Erişilebilirlik profilleri",
  "Motor Impaired": "Motor engeli",
  "Big cursor, voice navigation, and no animations.": "Büyük imleç, sesli gezinme ve animasyonsuz.",
  "Blind": "Görme engelli",
  "Screen reader helpers with higher contrast.": "Daha yüksek kontrastlı ekran okuyucu yardımcıları.",
  "Color Blind": "Renk körü",
  "High contrast palette with desaturated media.": "Desature medya ile yüksek kontrastlı palet.",
  "Dyslexia": "Disleksi",
  "Friendly font, extra spacing, stronger weight.": "Okunaklı yazı tipi, ekstra boşluk ve daha kalın ağırlık.",
  "Low vision": "Az gören",
  "Dark contrast and 130% magnification.": "Koyu kontrast ve %130 büyütme.",
  "Cognitive & Learning": "Bilişsel ve öğrenme",
  "Highlights key sections and enables voice help.": "Önemli bölümleri vurgular ve sesli yardımı etkinleştirir.",
  "Seizure & Epileptic": "Nöbet ve epilepsi",
  "Stops animations and desaturates imagery.": "Animasyonları durdurur ve görselleri soluklaştırır.",
  "ADHD": "DEHB",
  "Reading guide, highlighted links, calmer palette.": "Okuma rehberi, vurgulanan bağlantılar ve daha sakin palet.",
  "Widget Size": "Bileşen Boyutu",
  "Default": "Varsayılan",
  "Medium": "Orta",
  "Small": "Küçük",
  "Color Blindness": "Renk Körlüğü",
  "Protanopia": "Protanopi",
  "Deuteranopia": "Döteranopi",
  "Tritanopia": "Tritanopi",
  "Achromatopsia": "Akromatopsi",
  "Simulates and assists users with color vision deficiencies.": "Renk görme bozukluğu olan kullanıcıları simüle eder ve yardımcı olur."
}
